import { createSvgComponent } from "../../icon/createSvgComponent";
import Calculator from "@core/__generated__/icon/figma/calculator.svg";
export default createSvgComponent(Calculator);